import React, { Component } from 'react';
import axios from "axios";
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import Toast from './toast';
class TradeImportComponent extends React.Component<any, any> {

    // API Endpoints
    custom_file_upload_url = `https://gatewayapi.invest19.com/api/ipo/document/upload`;
    canvas: any;

    // state
    constructor(props) {
        super(props);
        this.canvas = React.createRef()
        this.state = {
            image_file: null,
            image_preview: '',
            uploadURL: '',
            url: '',
            uploadPercentage: 0,
            isUploaded: false,
            toastOpen: false,
            toastMessage: '',
            toastSeverity: 'success'
        }
    }

    // Image Preview Handler
    handleImagePreview = (e) => {
        let image_as_base64 = URL.createObjectURL(e.target.files[0])
        let image_as_files = e.target.files[0];

        this.setState({
            image_preview: image_as_base64,
            image_file: image_as_files,
            uploadPercentage: 0
        })
    }

    // Image/File Submit Handler
    handleSubmitFile = () => {
        if (this.state.image_file !== null) {

            let formData = new FormData();
            formData.append('ipoName', 'ipo');
            formData.append('document', this.state.image_file);
            var ref = this;

            this.setState({ uploadPercentage: 1 }); // Start progress

            axios.post(
                this.custom_file_upload_url,
                formData,
                {
                    headers: {
                        // "Authorization": "YOUR_API_AUTHORIZATION_KEY_SHOULD_GOES_HERE_IF_HAVE",
                        "Content-type": "multipart/form-data",
                    },
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        this.setState({ uploadPercentage: percentCompleted });
                    }
                }
            )
                .then(res => {
                    console.log(`Success`, res.data);

                    // Clear progress bar after a delay 
                    setTimeout(() => {
                        this.setState({ uploadPercentage: 0 })
                    }, 3000);

                    this.setState({
                        isUploaded: true,
                        toastOpen: true,
                        toastMessage: 'Successfully Uploaded',
                        toastSeverity: 'success'
                    });

                    // Extract url from the response structure correctly
                    if (res.data && res.data.response && res.data.response.url) {
                        ref.props.upload(res.data.response.url);
                    } else if (res.data && res.data.url) {
                        ref.props.upload(res.data.url);
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.setState({
                        uploadPercentage: 0,
                        toastOpen: true,
                        toastMessage: 'Upload failed: ' + err.message,
                        toastSeverity: 'error'
                    });
                })
        }
    }

    handleToastClose = () => {
        this.setState({ toastOpen: false });
    }

    // Cancel Selection Handler
    handleCancel = () => {
        this.setState({
            image_file: null,
            image_preview: '',
            uploadPercentage: 0,
            errorMessage: '',
            isUploaded: false
        });
        // Reset the actual input value so the same file can be selected again
        if (this.canvas && this.canvas.current) {
            this.canvas.current.value = "";
        }
    }

    // render from here
    render() {
        const { uploadPercentage, image_preview } = this.state;
        return (
            <div className="custom-image-upload" style={{ width: '100%', marginTop: '10px' }}>
                <Toast
                    open={this.state.toastOpen}
                    message={this.state.toastMessage}
                    severity={this.state.toastSeverity}
                    handleClose={this.handleToastClose}
                />

                {/* Hidden File Input */}
                <input
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    onChange={this.handleImagePreview}
                    ref={this.canvas}
                    style={{ display: 'none' }}
                />

                <div style={{ display: 'flex', alignItems: 'center', minHeight: '40px', border: '1px solid #ccc', borderRadius: '4px', padding: '5px 10px' }}>

                    {/* STATE 1: No Image Selected */}
                    {!image_preview && (
                        <div
                            style={{ width: '100%', cursor: 'pointer', textAlign: 'center', color: '#666', padding: '5px 0' }}
                            onClick={() => { if (this.canvas.current) this.canvas.current.click() }}
                        >
                            Select your file
                        </div>
                    )}

                    {/* STATE 2: Image Selected (Show Preview + Actions) */}
                    {image_preview && (
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>

                            {/* The Image Preview thumbnail */}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    src={image_preview}
                                    alt="Preview"
                                    style={{ maxWidth: '40px', maxHeight: '40px', objectFit: 'contain', marginRight: '15px', borderRadius: '4px', border: '1px solid #eee' }}
                                />
                                <span style={{ fontSize: '13px', color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100px' }}>
                                    {this.state.image_file ? this.state.image_file.name : 'Image selected'}
                                </span>
                            </div>

                            {/* The Action Buttons (Upload / Cancel) */}
                            <div style={{ display: 'flex' }}>


                                {!this.state.isUploaded && (
                                    <CheckRoundedIcon onClick={this.handleSubmitFile} style={{ cursor: 'pointer', color: '#4caf50' }} />
                                )}
                                {uploadPercentage === 0 && (
                                    <CloseRoundedIcon onClick={this.handleCancel} style={{ marginLeft: this.state.isUploaded ? '0' : '10px', cursor: 'pointer', color: '#f44336' }} />
                                )}


                            </div>

                        </div>
                    )}
                </div>

                {/* Upload Progress Bar spanning full width below the box */}
                <div style={{ width: '100%', marginTop: '5px', height: '4px' }}>
                    {uploadPercentage > 0 && <LinearProgress variant="determinate" value={uploadPercentage} />}
                </div>

            </div >
        );
    }
}

export default TradeImportComponent;
